import { Col } from '@landsbankinn/ui-kit';
import { type ReactNode, useState } from 'react';
import { useApplicationClientContext } from 'src/state';
import {
  OperationalStatusComponentId,
  OperationalStatusEnum,
} from '../../../gql/__generated__/graphql';
import { useFetchOperationalStatus } from '../../Login/hooks/useFetchOperationalStatus';
import { TopNotification } from '../TopNotification';
import { CultureSelector } from './CultureSelector';
import { Header } from './Header';

export function Mobile(props: { children?: ReactNode }) {
  const [clientState] = useApplicationClientContext();
  const [isCultureSelectorOpen, setCultureSelectorOpen] = useState(false);
  const { operationalStatus } = useFetchOperationalStatus(
    OperationalStatusComponentId.LOGIN,
  );
  const hasAnyTopNotification =
    operationalStatus?.status === OperationalStatusEnum.DegradedPerformance ||
    operationalStatus?.status === OperationalStatusEnum.Info
      ? true
      : false;

  return (
    <Col height="100dvh">
      <Header
        onCultureSelectorToggle={
          clientState.isLandsbankinnApp
            ? undefined
            : (isOpen) => setCultureSelectorOpen(isOpen)
        }
        isCultureSelectorOpen={isCultureSelectorOpen}
      />

      {operationalStatus && hasAnyTopNotification && (
        <TopNotification {...operationalStatus} />
      )}

      <Col
        marginHorizontal="0"
        paddingHorizontal="36"
        paddingTop="56"
        color="blue font"
        grow="1"
      >
        <Col paddingHorizontal="0" width="100%" height="100%">
          {isCultureSelectorOpen && (
            <CultureSelector onChange={() => setCultureSelectorOpen(false)} />
          )}
          {!isCultureSelectorOpen && props.children}
        </Col>
      </Col>
    </Col>
  );
}
